import moment from "moment";
import { ETAPAS_PROJETO, SEGMENTO_PROJETO, UNIDADE_TEMPO, TIPO_PROJETO, SITUACAO_PEDIDO, ETAPAS_PEDIDO } from "./constants";

export function getEtapaVenda(codigo: number, isNF: boolean):string {
    /*
        1 THEN 'Projeto Iniciado'
        2 THEN 'Proposta Inicial Enviada'
        3 THEN 'Proposta Final Enviada'
        4 THEN 'Em Negociação'
        5 THEN 'Expirado'
        6 THEN 'Cancelado'
        7 THEN 'Pagamento aprovado'
        8 THEN 'Processando informações de pedido'
        9 THEN 'Em trânsito'
        10 THEN 'Produto entregue'
        11 THEN 'Projeto finalizado'
        12 THEN 'Visita Técnica Efetuada'
        13 THEN 'Em análise de financiamento'
    */
    switch (codigo) {
        case 1: return ETAPAS_PROJETO.PRE_ORCAMENTO;
        case 2: return ETAPAS_PROJETO.PRE_ORCAMENTO;
        case 3: return ETAPAS_PROJETO.PROPOSTA_FINAL;
        case 4: return ETAPAS_PROJETO.NEGOCIACAO;
        case 5: return ETAPAS_PROJETO.EXPIRADO;
        case 6: return ETAPAS_PROJETO.CANCELADO;
        case 7: return ETAPAS_PROJETO.PAGAMENTO_APROVADO;
        case 8:
            if (isNF) {
                return ETAPAS_PROJETO.FATURADO;
            } else {
                return ETAPAS_PROJETO.AGUARDANDO_FATURAMENTO;
            }
        case 9: return ETAPAS_PROJETO.EM_TRANSITO;
        case 10: return ETAPAS_PROJETO.ENTREGUE;
        case 11: return ETAPAS_PROJETO.FINALIZADO;
        case 12: return ETAPAS_PROJETO.VISITADO;
        case 13: return ETAPAS_PROJETO.PROPOSTA_FINAL;
        default: return "";
    }
}

export function getTipoProjeto(codigo: string, projetoV1?: any) {
    const { OpcaoVenda, IsV2 } = projetoV1;
    if (codigo?.includes("KOND")) return TIPO_PROJETO.KIT;
    if (codigo?.includes("KOFD")) return TIPO_PROJETO.KIT;
    if (codigo?.includes("KONV")) return TIPO_PROJETO.KIT;
    if (codigo?.includes("KOFV")) return TIPO_PROJETO.KIT;
    if (codigo?.includes("KIT")) return TIPO_PROJETO.KIT;
    if (codigo?.includes("AOND")) return TIPO_PROJETO.AVULSO;
    if (codigo?.includes("AOFD")) return TIPO_PROJETO.AVULSO;
    if (codigo?.includes("MOND")) return TIPO_PROJETO.MISTO;
    if (codigo?.includes("MOFD")) return TIPO_PROJETO.MISTO;
    if (codigo?.includes("PROV")) {
        if (Number(IsV2) === 0) {
            if (OpcaoVenda !== null) return TIPO_PROJETO.PERSONALIZADO; 
            else return TIPO_PROJETO.DIMENSIONADO;
        }
        return TIPO_PROJETO.VERTICAL;
    }

    if (OpcaoVenda !== null) return TIPO_PROJETO.PERSONALIZADO; 
    else return TIPO_PROJETO.DIMENSIONADO;
}

export function getSegmento(tipoProjeto?: number) {
    // VerticalV1 = 1,
    // VerticalV2 = 2,
    // OffGrid = 3,
    // OffGridVertical = 4,
    // AvulsoOnGridDist = 5,
    // AvulsoOnGridVert = 6,
    // AvulsoOffGridDist = 7,
    // AvulsoOffGridVert = 8,

    switch (tipoProjeto) {
        case 1:
            return SEGMENTO_PROJETO.VERTICAL_ONGRID;
        case 2:
            return SEGMENTO_PROJETO.VERTICAL_ONGRID;
        case 3:
            return SEGMENTO_PROJETO.DISTRIBUICAO_OFFGRID;
        case 4:
            return SEGMENTO_PROJETO.VERTICAL_OFFGRID;
        case 5:
            return SEGMENTO_PROJETO.DISTRIBUICAO_ONGRID;
        case 6:
            return SEGMENTO_PROJETO.VERTICAL_ONGRID;
        case 7:
            return SEGMENTO_PROJETO.DISTRIBUICAO_OFFGRID;
        case 8:
            return SEGMENTO_PROJETO.VERTICAL_OFFGRID;
        default:
            return SEGMENTO_PROJETO.DISTRIBUICAO_ONGRID;
    }
}

export function getUnidadeTempo(periodo: number) {
    switch (periodo) {
        case 1:
            return UNIDADE_TEMPO.ANOS;
        case 2:
            return UNIDADE_TEMPO.MESES;
        default:
            return UNIDADE_TEMPO.ANOS;
    }
}

export function getTipoConexao(fase: number) {
    switch (fase) {
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 3;
        default:
            return 1;
    }
}

export function getPosicaoFileiras(posicao: number) {
    switch (posicao) {
        case 1:
            return "retrato";
        case 2:
            return "paisagem";
        default:
            return "retrato";
    }
}

export function getDestino(opcaoVenda: number) {
    switch (opcaoVenda) {
        case 1:
            return "revenda";
        case 3:
            return "triangular";
        default:
            return "cliente";
    }
}

export function getTipoFaturamento(opcaoVenda: number) {
    switch (opcaoVenda) {
        case 1:
            return "integrador";
        case 3:
            return "integrador_cliente";
        default:
            return "cliente";
    }
}

export function getTipoPagamento(tipo: number) {
    switch (tipo) {
        case 1:
            return "Apenas Gerador sem Instalação";
        case 2:
            return "Gerador com Serviço de Instalação";
        default:
            return "";
    }
}

export function getCodigoVenda(projeto: any) {
    // VERTICALV1 = 1 (Projeto vertical v1)
    // VERTICALV2 = 2 (Projeto vertical v2)
    // OffGrid = 3 (KIT OffGrid Distribuicao)
    // OffGridVertical = 4 (KIT OffGrid Vertical)
    // AvulsoOnGridDist = 5 (Avulso OnGrid Distribuicao)
    // AvulsoOnGridVert = 6 (Avulso OnGrid Vertical)
    // AvulsoOffGridDist = 7 (Avulso OffGrid Distribuicao)
    // AvulsoOffGridVert = 8 (Avulso OffGrid Vertical)

    let sigla = "PROJ";
    const dataCriacao = new Date(String(projeto?.DataCriacao));
    if (projeto?.KitGeradorId != null && projeto?.TipoProjeto === 1) sigla = "KITV";
    else if (projeto?.TipoProjeto === 1 || projeto?.TipoProjeto === 2) sigla = "PROV";
    else if (projeto?.KitGeradorId !== null && projeto?.TipoProjeto === 3) sigla = "KOFD";
    else if (projeto?.KitGeradorId !== null && projeto?.TipoProjeto === 4) sigla = "KOFS";
    else if (projeto?.KitGeradorId !== null && projeto?.TipoProjeto === 5) sigla = "AOND";
    else if (projeto?.KitGeradorId !== null && projeto?.TipoProjeto === 6) sigla = "AOGS";
    else if (projeto?.KitGeradorId !== null && projeto?.TipoProjeto === 7) sigla = "AOFD";
    else if (projeto?.KitGeradorId !== null && projeto?.TipoProjeto === 8) sigla = "AOFS";
    else if (projeto?.KitGeradorId !== null) sigla = "KIT";

    return sigla + `${dataCriacao.getFullYear().toString().substr(-2)}${('0' + (dataCriacao.getMonth() + 1)).slice(-2)}${projeto?.Id}`;
}

export function getTipoDocumentoServico(tipo: number) {
    // NotaFiscalServico = 2,
    // DocumentoIdentificacaoCliente = 3,
    // OrdemServicoAssinadaCliente = 4,
    // ArtTrt = 5
    switch (tipo) {
        case 2:
            return "nf_servico_instalacao";
        case 3:
            return "identificacao_cliente";
        case 4:
            return "ordem_servico";
        case 5:
            return "art_trt_projeto";
        default:
            return null;
    }
}

export function getSituacaoPedido(codigo: number) {
    if (codigo === 11) return SITUACAO_PEDIDO.FINALIZADO;
    if (codigo === 6) return SITUACAO_PEDIDO.CANCELADO;
    return SITUACAO_PEDIDO.PENDENTE;
}

export function getEtapaVendaPedido(codigo: number, isNF: boolean) {
    /*
        1 THEN 'Projeto Iniciado'
        2 THEN 'Proposta Inicial Enviada'
        3 THEN 'Proposta Final Enviada'
        4 THEN 'Em Negociação'
        6 THEN 'Cancelado'
        7 THEN 'Pagamento aprovado'
        8 THEN 'Processando informações de pedido'
        9 THEN 'Em trânsito'
        10 THEN 'Produto entregue'
        11 THEN 'Projeto finalizado'
        13 THEN 'Em análise de financiamento'
    */
    switch (codigo) {
        case 1: return ETAPAS_PEDIDO.ENVIO_PAGAMENTO;
        case 2: return ETAPAS_PEDIDO.ENVIO_PAGAMENTO;
        case 3: return ETAPAS_PEDIDO.ENVIO_PAGAMENTO;
        case 4: return ETAPAS_PEDIDO.AGUARDANDO_PAGAMENTO;
        case 7: return ETAPAS_PEDIDO.AGUARDANDO_FATURAMENTO;
        case 8:
            if (isNF) {
                return ETAPAS_PEDIDO.FATURADO;
            } else {
                return ETAPAS_PEDIDO.AGUARDANDO_FATURAMENTO;
            }
        case 9: return ETAPAS_PEDIDO.EM_TRANSITO;
        case 10: return ETAPAS_PEDIDO.ENTREGUE;
        case 11: return ETAPAS_PEDIDO.ENTREGUE;
        case 13: return ETAPAS_PEDIDO.AGUARDANDO_FATURAMENTO;
        default: return ETAPAS_PEDIDO.ENVIO_PAGAMENTO;
    }
}

export function arrayEquals(a: any, b: any) {
    return JSON.stringify(a) === JSON.stringify(b);
}

export function arraySort(item: any[], key: string, type: string = 'number', order: string = 'asc') {
    if (!item?.length) return item;

    if (order === 'asc') {
        if (type === 'number') item?.sort((a:any, b:any) => - (Number(a[key]) - Number(b[key])));
        if (type === 'string') item?.sort((a:any, b:any) => - (a[key]) - b[key]);
        if (type === 'date') item?.sort((a:any, b:any) => {
            const dateA = new Date(a[key]).getTime();
            const dateB = new Date(b[key]).getTime();
            return dateA - dateB;
        });
    } else {
        if (type === 'number') item?.sort((a:any, b:any) => - (Number(b[key]) - Number(a[key])));
        if (type === 'string') item?.sort((a:any, b:any) => - (b[key]) - a[key]);
        if (type === 'date') item?.sort((a:any, b:any) => {
            const dateA = new Date(a[key]).getTime();
            const dateB = new Date(b[key]).getTime();
            return dateB - dateA;
        });
    }
    return item;
}

export function formatData(data: any): string {
    if (!data) return "";
    if (String(data)?.includes("GMT")) {
      return moment(data).utc().format("DD/MM/YYYY - HH:mm:ss");
    } else if (String(data)?.includes('T')) {
      const formated =  String(data)?.replace('T', ' ')?.replace('Z', '');
      return moment(formated).format("DD/MM/YYYY - HH:mm:ss");
    }
    return moment(data).format("DD/MM/YYYY - HH:mm:ss");
  }